const isProduction = 1; 
const API_STAGING = 'https://cgbalv7l6h.execute-api.eu-west-2.amazonaws.com/dev';

const API_PROD = 'https://api-credit.jivebird.com';

const FE_URL_PROD = 'https://www.web.jivebird.com';
const FE_URL_STAG = 'https://staging.d2md0e5utikkzs.amplifyapp.com';

export const S3_URL = 'https://jivebirdbucketprod.s3.amazonaws.com';

export const ENDPOINT = isProduction ? API_PROD : API_STAGING;
export const FE_ENDPOINT = isProduction ? FE_URL_PROD : FE_URL_STAG;